import React from 'react';
import { ListItemText, Grid, Typography } from '@material-ui/core';
import { access, UserAccess } from '../../../model/access';
import moment from 'moment';

export function AccessInfo(props: {
    access: access;
    classes: any;
    showContactInfo: boolean;
    // setSelected: (value: any) => void; 
    // clickItem: (_id: string) => void;
}) {
    const { access } = props;

    const format = "YYYY-MM-DD HH:mm:ss";
    var accessDateTime = moment(access.accessTimestamp).format(format);

    var obj = { Access: access.accessAllowed };

    // accessAllowed: false
    // accessTimestamp: "2021-11-17T14:21:02.751Z"
    // activitySceduledId: null
    // cognome: "Crava"
    // dayCode: null
    // email: "crava2199@gmail.com"
    // nome: "Paolo"
    // reservationStart: "2021-11-17T15:00:00Z"
    // roomId: "611a66e9cdae690eff1780b5"
    // userId: "google-oauth2|103845684685025938087"
    // verifyDetail: "{\"Access\":true,\"Message1\":\"CIAO\",\"Message2\":\"CRAVOSSI\",\"Message3\":\"ACCESSO OK----------\",\"Message4\":\"INIZIO ALLE 15:00 UTC\",\"AccessId\":\"\"}"
    // _id: "61950fcebe9e1265b3ea5475"

    var _backgroundColor = '#efefef';   // GRIGIO

    if (obj.Access) {
        _backgroundColor = '#00e812';   // VERDE
    }
    else {
        _backgroundColor = '#e80000';   // ROSSO
    }

    try {
        obj = JSON.parse(access.verifyDetail);
    } catch (error) {
        console.warn(access.verifyDetail);
        _backgroundColor = '#ff6600';   // ARANCIO
    }

    // let name = `${reminder.nome} ${reminder.cognome}`;
    // let email = `${reminder.email}`;
    // let text = `${reminder.notes}`;
    // let expiresOn = '';
    // let days = 0;
    // console.log("--------------------------------------------------------------------");
    // console.log(reminder.expiresOn);
    // console.log(m.toDateString);
    // if (reminder.expiresOn !== null) {
    //     var m = moment(reminder.expiresOn);
    //     expiresOn = m.toDate().toLocaleDateString();
    //     let today = moment();
    //     days = m.diff(today, 'days'); // 1
    //     // expiresOn = `${reminder?.expiresOn?.toLocaleDateString()}`;
    // }
    // onClick={() => props.clickItem(access._id)} 


    const drawMessages = (_messages: any) => {
        // console.log("DRAWWWWWWWWWWWWWWWWWW :", _messages);
        try {
            var c = (JSON.parse(_messages) as UserAccess).Messages.map((x, index) => {
                return <span key={index}>{x}</span>
            });
            // console.log("DRAWWWWWWWWWWWWWWWWWW :", c);
            return <Typography style={{ display: 'grid', fontSize: '12px', fontWeight: 600 }}>{c}</Typography>
            // {"Access":false,"Messages":["CIAO PAOLO CRAVA","Codice: google-oauth2|103845684685025938087","Abbonamento scaduto o non presente","Visita medica valida. Scandenza 02/02/2022 16:56:50","Assicurazione valida. Scandenza 02/02/2022 16:56:50"],"AccessId":""}
        } catch (error) {
            return <Typography>{_messages}</Typography>
        }
    }

    return <Grid container style={{ backgroundColor: _backgroundColor }}>
        <Grid item xs={12} style={{ padding: '2px', cursor: 'text' }}>
            <ListItemText primary={drawMessages(access.verifyDetail)} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { fontSize: '10px', display: 'block' } }} />
            <ListItemText primary={accessDateTime + " | " + (access.userId ?? '')} primaryTypographyProps={{ noWrap: true, variant: 'body1', style: { fontSize: '10px', display: 'block', backgroundColor: 'white', padding: '2px 0px 0px 2px' } }} />
        </Grid>
        {/* <Grid item xs={1}>
            <ToggleButton value="check" className={days < 1 ? props.classes.checkedred : (days < 5 ? props.classes.checkedorange : props.classes.checkedorangelt)}
                selected={reminder.done}
                onChange={() => { props.setSelected(!reminder.done); } }>
                <Check />
            </ToggleButton>
        </Grid> */}
    </Grid>;
}